import { useCallback } from "react";

const OUT_OF_STOCK = "OUT OF STOCK";

export const useGetBrandInfo = ({ info, cashBack, available }) => {
  const generateDiscountString = (infoParam, availableParam) => {
    const discountString = infoParam.toUpperCase();
    const percentage = parseFloat(infoParam.match(/\b\d+(?:\.\d+)?/));

    if (!availableParam) return OUT_OF_STOCK;

    if (!percentage) return null;

    return discountString;
  };

  const generateCashBackString = (cashBackParam) => {
    const percentage = parseFloat(cashBackParam).toFixed(2);
    if (percentage > 0) return `${percentage}% GCX Cash`;
    return null;
  };

  const generateBrandInfoString = useCallback(() => {
    const discountString = generateDiscountString(info, available);
    const cashBackString = generateCashBackString(cashBack);
    const isOutOfStock = discountString === "OUT OF STOCK";

    if (discountString && cashBackString && !isOutOfStock) {
      return `${discountString} | ${cashBackString}`;
    } else if (cashBackString) {
      return cashBackString;
    } else if (discountString) {
      return discountString;
    }

    return "";
  }, [available, cashBack, info]);

  return {
    generateBrandInfoString
  };
};
